import Datetime from '../../libs/vue-datetime/index.js'
export default {
    name: "addAunt",
    data: function() {
        return {
            isMiniProgram: this.$isMiniProgram(), //是否小程序环境
            isAPP: false, //是否APP环境
            servantId: this.$route.query.servantId,
            //平台: 0:用户端(排除),2:客户经理端,3:服务师端(默认)
            platform: this.$route.query.platform ? parseInt(this.$route.query.platform) : 3,
            //上一页面: 0:不确认,1:用户端服务师列表(排除),2:客户经理端服务师列表,3:服务师端首页(默认)
            fromPage: this.$route.query.fromPage ? parseInt(this.$route.query.fromPage) : 3,
            tab: "info",
            existed: false,
            existState: 0,
            info: {
                Birthday: "",
            },
            ////==== 基本信息
            sexList: [], //性别
            educationList: [], //学历
            selectEducation: {},
            marriageList: [], //婚姻状态
            selectMarriage: {},
            zodiacList: [], //属相
            selectZodiac: {},


            ////==== 身份证件
            certifyList: [], //证书
            selectCertify: {},
            curCertify: {}, //当前要上传照片的证书

            ////==== 工作类型
            workTypeList: [ //工作类型
                {
                    Key: 1,
                    Value: "TemporaryHourLabour",
                    Name: "临时保洁",
                    Selected: false,
                },
                {
                    Key: 2,
                    Value: "MonthHourLabour",
                    Name: "长期钟点工",
                    Selected: false,
                },
                {
                    Key: 3,
                    Value: "WorkdaysNanny",
                    Name: "全天保姆",
                    Selected: false,
                },
                {
                    Key: 4,
                    Value: "LiveInCaregiver",
                    Name: "住家保姆",
                    Selected: false,
                },
                {
                    Key: 5,
                    Value: "ConfinementNurse",
                    Name: "月嫂",
                    Selected: false,
                },
                {
                    Key: 6,
                    Value: "InfantCare",
                    Name: "育婴师",
                    Selected: false,
                },
            ],
            workTimeList: [], //工作时间
            addressList: [], //行政区域
            workingSkills: [{ SkillType: 2, SkillTypeStr: "母婴" },
                { SkillType: 4, SkillTypeStr: "育儿" },
                { SkillType: 5, SkillTypeStr: "护工" },
                { SkillType: 1, SkillTypeStr: "保洁" },
                { SkillType: 3, SkillTypeStr: "烹饪" }
            ],
            serviceContentList: [ //服务内容
                {
                    Id: 1,
                    Name: "做饭",
                    Selected: false
                },
                {
                    Id: 2,
                    Name: "做家务",
                    Selected: false
                },
                {
                    Id: 32,
                    Name: "照顾母婴",
                    Selected: false
                },
                {
                    Id: 9,
                    Name: "照顾孩子",
                    Selected: false
                },
                {
                    Id: 4,
                    Name: "照顾自理老人",
                    Selected: false
                },
                {
                    Id: 5,
                    Name: "照顾不能自理老人",
                    Selected: false
                },
                {
                    Id: 36,
                    Name: "照顾病人",
                    Selected: false
                },
                {
                    Id: 8,
                    Name: "饲养宠物",
                    Selected: false
                },
                {
                    Id: 99,
                    Name: "其它",
                    Selected: false
                },
            ],
            yearList: [{ string: "1-3年" },
                { string: "3-5年" },
                { string: "5-10年" },
                { string: "10年以上" }
            ],
            selectYear: {},

            //日历组件
            minDatetime: "1900-01-01T00:00:00",
            maxDatetime: "2018-07-20T00:00:00", //最大可选日期
            effectiveStep: 365, //有效时间段,单位: day
            isOpenCalendar: false, //是否打开日历面板
            isFullPage: false, //main是否全屏

            testImg: "", //测试图片
        }
    },
    components: {
        'datetime': Datetime
    },
    mounted: function() {
        this.init();
    },
    watch: {
        '$route': function(to, from) {
            if (to && (to.name === 'addAunt' || to.name === 'serverProfile')) {
                this.init();
            }
        }
    },
    methods: {
        //上传照片 - 打开相机
        setTestImg() {
            let self = this;
            if (this.isMiniProgram) {
                this.$get("/auth/wechat/config", {
                    url: process.env.domainHost + "/serverProfile?platform=3&fromPage=3"
                }, function(res) {
                    if (res.Success) {
                        if (res.Result && res.Result.AppId) {
                            alert("请求签名成功：" + res.Result.AppId);
                            self.$miniProgram_ChooseImage(1, 3, 1, res.Result, function(res) {
                                let photo = res;
                                if (photo && photo.length > 0) {
                                    self.testImg = photo[0];
                                } else {
                                    self.$toast("选择照片失败");
                                }
                            });
                        }
                    } else {
                        self.$toast(res.Message);
                    }
                });
            } else {
                self.$toast("不是小程序环境");
            }
        },
        range: function(n) {
            return new Array(n);
        },
        init() {
            this.initCalendarLimit();
            this.isMiniProgram = this.$isMiniProgram();
            this.checkAPP();
            this.platform = this.$route.query.platform ? parseInt(this.$route.query.platform) : 3;
            this.fromPage = this.$route.query.fromPage ? parseInt(this.$route.query.fromPage) : 3;
            this.tab = "info";
            this.existed = false;
            this.existState = 0;
            this.info = {
                Cellphone: "",
                ServantPhoto: "",
                ListServantPicture: [],
                Birthday: "",
                ServantSkill: [],
            };

            this.getSelectList();
            this.initWorkTypeList();
            this.initServiceContentList();
            if (this.platform == 3) {
                this.getProfile();
            } else {
                this.initSelector();
            }
        },
        //获取个人信息
        getProfile() {
            let self = this;
            this.$get("/servant/getservantdetail", function(res) {
                if (res.Success) {
                    if (res.Result && res.Result.ServantId) {
                        //先取原来证件列表
                        let originListServantPicture = JSON.parse(JSON.stringify(self.info.ListServantPicture));
                        //处理数据
                        self.info = res.Result;
                        if (!self.info.Birthday) {
                            self.info.Birthday = "";
                        } else {
                            self.info.Birthday = self.info.Birthday.split("T")[0];
                            if (self.info.Birthday == "0001-01-01") {
                                self.info.Birthday = "";
                            }
                        }
                        self.initSelector();
                        self.selectEducation = {
                            Key: self.info.Education,
                            Name: self.info.EducationStr,
                        };
                        self.selectMarriage = {
                            Key: self.info.MaritalStatus,
                            Name: self.info.MaritalStatusStr,
                        };
                        self.selectZodiac = {
                            Key: self.info.ZodiacType,
                            Name: self.info.ZodiacTypeStr,
                        };
                        //如果新详情证件数据为空，而旧证件数据不为空，则把旧数据赋值给新数据 - 防止新数据在获取证件列表方法（getSelectList）之后执行
                        if (!self.info.ListServantPicture || self.info.ListServantPicture.length <= 0) {
                            if (originListServantPicture && originListServantPicture.length > 0) {
                                self.info.ListServantPicture = JSON.parse(JSON.stringify(originListServantPicture));
                            }
                        }
                        self.initWorkTypeList();
                        self.initServiceContentList();
                    }
                } else {
                    self.$toast(res.Message);
                }
            });
        },

        //初始化下拉框信息
        initSelector() {
            let self = this;
            //性别
            this.sexList = [{
                    key: "未设置",
                    val: 0,
                    selected: true,
                },
                {
                    key: "男",
                    val: 1,
                    selected: false,
                },
                {
                    key: "女",
                    val: 2,
                    selected: false,
                },
            ];
            let curSex = this.info && this.info.Sex ? this.info.Sex : 0;
            this.sexList.map((item, index) => {
                let newItem = item;
                if (item.val == curSex) {
                    newItem.selected = true;
                } else {
                    newItem.selected = false;
                }
                self.sexList.splice(index, 1, newItem);
            });
        },
        //修改下拉框信息
        chgSelector(fieldList, fieldName) {
            let self = this;
            this[fieldList].map(item => {
                if (item.selected) {
                    self.info[fieldName] = item.val;
                }
            });
        },
        //初始化日历组件的时间限制
        initCalendarLimit() {
            // let endDateTime = new Date();
            // let endYear = endDateTime.getFullYear();
            // let endMonth = endDateTime.getMonth() + 1;
            // endMonth = this.formatDigit(endMonth.toString());
            // let endDate = endDateTime.getDate();
            // endDate = this.formatDigit(endDate.toString());
            // this.maxDatetime = endYear + "-" + endMonth + "-" + endDate;
            // console.log(this.maxDatetime);

            let endDateTime = new Date();
            let endYear = endDateTime.getFullYear();
            let endMonth = endDateTime.getMonth() + 1;
            if (endMonth.toString().length < 2) {
                endMonth = "0" + endMonth;
            }
            let endDate = endDateTime.getDate();
            if (endDate.toString().length < 2) {
                endDate = "0" + endDate;
            }
            let endHour = endDateTime.getHours();
            if (endHour.toString().length < 2) {
                endHour = "0" + endHour;
            }
            let endMinute = endDateTime.getMinutes();
            if (endMinute.toString().length < 2) {
                endMinute = "0" + endMinute;
            }
            let endSecond = endDateTime.getSeconds();
            if (endSecond.toString().length < 2) {
                endSecond = "0" + endSecond;
            }
            this.maxDatetime = endYear + "-" + endMonth + "-" + endDate + "T" + endHour + ":" + endMinute + ":" + endSecond;
        },
        //格式化数字长度
        formatDigit(str) {
            if (str.length < 2) {
                str = "0" + str;
            }
            return str;
        },
        //打开日历面板触发
        openCalendar() {
            this.isOpenCalendar = true;
        },
        //关闭日历面板触发
        closeCalendar() {
            this.isOpenCalendar = false;
        },
        ////////////////////////////


        getServent: function(cellphone) {
            var _this = this;

            if (!cellphone) return;
            if (cellphone.length != 11) {
                _this.$toast('请输入11位手机号');
                return;
            }
            _this.existed = false;
            _this.existState = 0;

            this.$get("servant/queryifexist", {
                phone: cellphone
            }, function(res) {
                if (res.Success) {
                    if (res.Result && res.Result.IfExist) {
                        _this.existed = true;
                        _this.existState = res.Result.ExistState;
                        _this.info = res.Result.ServantInfo;
                        _this.info.ServantSkill = _this.info.ServantSkill || [];

                        _this.initWorkTypeList();
                    }

                } else {
                    _this.$toast(res.Message);
                }
            });
        },
        getSelectList: function() {
            var _this = this;
            this.$get("query/getaddservantallset", function(res) {
                if (res.Success) {
                    _this.certifyList = res.Result.ListCertificateType;
                    // if (_this.platform != 3) {
                    _this.selectCertify = _this.certifyList[0];
                    if (_this.info.ListServantPicture.length <= 0) {
                        let newServantPictureItem = {
                            "PositivePhoto": "",
                            "ReversePhoto": "",
                            "CertificateType": _this.certifyList[0].Key,
                            "CertificateTypeStr": _this.certifyList[0].Name
                        };
                        _this.info.ListServantPicture.push(newServantPictureItem);
                    }
                    // }
                    _this.marriageList = res.Result.ListMaritalStatus;
                    _this.educationList = res.Result.ListServantEducation;
                    _this.zodiacList = res.Result.ListZodiacType;
                } else {
                    _this.$toast(res.Message);
                }
            });
            this.$get("/query/listarea", {
                cityid: this.$getCity()
            }, function(res) {
                let areaList = res;
                if (areaList && areaList.length > 0) {
                    areaList.map(item => {
                        item.AreaId = item.Id;
                        item.AreaName = item.Areaname;
                    });
                }
                _this.addressList = areaList;
            })

            var rang24 = _this.range(24);
            for (var i = 0; i < rang24.length; i++) {
                _this.workTimeList.push({
                    Name: i + ':00',
                    Value: i,
                    BenginTime: i + ':00',
                    EndTime: i + ':00',
                });
            }

        },
        //检测是否APP环境
        checkAPP() {
            let self = this;
            let isAPP = dsBridge.hasNativeMethod('photo');
            self.isAPP = isAPP;
        },
        //上传照片 - 打开相册
        spPhoto(uploadImage) {
            let self = this;
            if (this.isMiniProgram) {
                // self.$miniProgram_ChooseImage(1, 3, 1, function(res) {
                //     let photo = res;
                //     if (photo && photo.length > 0) {
                //         self.info.ServantPhoto = photo[0];
                //     } else {
                //         self.$toast("选择照片失败");
                //     }
                // });
                this.doChgPhoto(uploadImage);
            } else {
                dsBridge.call("photo", {}, function(data) {
                    self.info.ServantPhoto = "data:image/jpeg;base64," + data;
                });
            }
        },
        //上传照片 - 打开相机
        spCamera(uploadImage) {
            let self = this;
            // let testImg = "http://tqimg.img-cn-shanghai.aliyuncs.com/mbr/servant/pt/62a58135f7034c8f95556733d76f503e.jpg";
            // let testImg = require("../../assets/images/i_logo.png");
            // self.$img2base64(testImg);
            // return false;
            if (this.isMiniProgram) {
                // self.$miniProgram_ChooseImage(1, 3, 2, function(res) {
                //     let photo = res;
                //     if (photo && photo.length > 0) {
                //         self.info.ServantPhoto = photo[0];
                //     } else {
                //         self.$toast("拍照失败");
                //     }
                // });
                this.doChgPhoto(uploadImage);
            } else {
                dsBridge.call("camera", {}, function(data) {
                    self.info.ServantPhoto = "data:image/jpeg;base64," + data;
                });
            }
        },
        //更改照片 - 上传组件返回
        doChgPhoto(uploadImage) {
            let self = this;
            if (uploadImage) {
                self.info.ServantPhoto = uploadImage.FilePath;
            }
        },
        checkEducationItem: function(options) {
            this.selectEducation = options;
        },
        checkZodiacItem: function(options) {
            this.selectZodiac = options;
        },
        checkYearItem: function(options) {
            this.selectYear = options;
        },
        checkMarriageItem: function(options) {
            this.selectMarriage = options;
        },
        //验证基本信息
        validateInfo() {
            let isPass = false;
            if (!this.$verifyPhone(this.info.Cellphone)) {
                this.$toast("请输入正确手机号！");
                isPass = false;
            } else if (!this.info.ServantName) {
                this.$toast("请输入姓名！");
                isPass = false;
            } else if (!this.info.Sex || this.info.Sex == 0) {
                this.$toast("请选择您的性别！");
                isPass = false;
            } else if (!this.info.Birthday || this.info.Birthday.split("T")[0] == "0001-01-01") {
                this.$toast("请设置您的生日！");
                isPass = false;
            } else if (!this.info.NativePlace) {
                this.$toast("请输入籍贯！");
                isPass = false;
            }
            // else if (!this.info.ServantPhoto) {
            //     this.$toast("请上传头像！");
            //     isPass = false;
            // }
            else {
                isPass = true;
            }
            return isPass;
        },
        infoNextStep: function() {
            let isPass = this.validateInfo();
            if (isPass) {
                this.tab = 'idCard';
            } else {
                return false;
            }
        },



        ///////////=============== 身份证件 ================
        //验证身份证件
        validateCard() {
            let isPass = false;
            if (!this.info.ListServantPicture || !this.info.ListServantPicture.length) {
                isPass = false;
            } else {
                this.info.ListServantPicture.map(item => {
                    if (item.PositivePhoto || item.ReversePhoto) {
                        isPass = true;
                    }
                });
            }
            if (!isPass) {
                this.$toast("请至少上传1张证件照！");
            }
            return isPass;
        },
        idCardNextStep: function() {
            let isPass = this.validateCard();
            if (isPass) {
                this.tab = 'type';
            } else {
                return false;
            }
        },


        checkCertifyItem: function(options) {
            this.selectCertify = options;
        },

        addServantPicture: function() {
            // console.log(this.selectCertify);
            var selectCertify = this.selectCertify;

            this.info.ListServantPicture = this.info.ListServantPicture || [];
            for (var i = 0; i < this.info.ListServantPicture.length; i++) {
                if (this.info.ListServantPicture[i].CertificateType == selectCertify.Key) {
                    return false;
                }
            }
            this.info.ListServantPicture.push({
                "PositivePhoto": "",
                "ReversePhoto": "",
                "CertificateType": selectCertify.Key,
                "CertificateTypeStr": selectCertify.Name
            });
        },
        //上传证件照
        chgCertify(paramObject, paramType, sourceType) { //证件，1正|2反面，1相册|2相机
            let self = this;
            // this.curCertify = JSON.parse(JSON.stringify(paramObject));
            // this.curCertify.side = paramType;
            if (self.isAPP) {
                if (paramType == 1) { //正面照
                    if (sourceType == 1) { //相册
                        dsBridge.call("photo", {}, function(data) {
                            paramObject.PositivePhoto = "data:image/jpeg;base64," + data;
                        });
                    } else { //相机
                        dsBridge.call("camera", {}, function(data) {
                            paramObject.PositivePhoto = "data:image/jpeg;base64," + data;
                        });
                    }
                } else if (paramType == 2) { //反面照
                    if (sourceType == 1) { //相册
                        dsBridge.call("photo", {}, function(data) {
                            paramObject.ReversePhoto = "data:image/jpeg;base64," + data;
                        });
                    } else { //相机
                        dsBridge.call("camera", {}, function(data) {
                            paramObject.ReversePhoto = "data:image/jpeg;base64," + data;
                        });
                    }
                }
            } else {
                this.curCertify = JSON.parse(JSON.stringify(paramObject));
                this.curCertify.side = paramType;
            }
        },
        //执行更改
        doChgCertify(uploadImage) {
            let self = this;
            if (uploadImage) {
                this.info.ListServantPicture = this.info.ListServantPicture || [];
                for (var i = 0; i < this.info.ListServantPicture.length; i++) {
                    if (this.info.ListServantPicture[i].CertificateType == this.curCertify.CertificateType) {
                        let newCertify = this.info.ListServantPicture[i];
                        if (this.curCertify.side == 1) { //正面照
                            newCertify.PositivePhoto = uploadImage.FilePath;
                        } else if (this.curCertify.side == 2) { //反面照
                            newCertify.ReversePhoto = uploadImage.FilePath;
                        }
                        this.info.ListServantPicture.splice(i, 1, newCertify);
                        break;
                    }
                }
            }
        },
        // //相机 - 正面照
        // lspPositiveCamera: function(lsp) {
        //     let self = this;
        //     if (this.isMiniProgram) {
        //         let photo = self.$miniProgram_ChooseImage(1, 3, 1);
        //         if (photo && photo.length > 0) {
        //             lsp.PositivePhoto = photo[0];
        //         } else {
        //             self.$toast("选择照片失败");
        //         }
        //     } else {
        //         dsBridge.call("camera", {}, function(data) {
        //             lsp.PositivePhoto = "data:image/jpeg;base64," + data;
        //         });
        //     }
        // },
        // //相册 - 正面照
        // lspPositivePhoto: function(lsp) {
        //     let self = this;
        //     if (this.isMiniProgram) {
        //         let photo = self.$miniProgram_ChooseImage(1, 3, 1);
        //         if (photo && photo.length > 0) {
        //             lsp.PositivePhoto = photo[0];
        //         } else {
        //             self.$toast("选择照片失败");
        //         }
        //     } else {
        //         dsBridge.call("photo", {}, function(data) {
        //             lsp.PositivePhoto = "data:image/jpeg;base64," + data;
        //         });
        //     }
        // },
        // //相机 - 反面照
        // lspReverseCamera: function(lsp) {
        //     let self = this;
        //     dsBridge.call("camera", {}, function(data) {
        //         lsp.ReversePhoto = "data:image/jpeg;base64," + data;
        //     });
        // },
        // //相册 - 反面照
        // lspReversePhoto: function(lsp) {
        //     let self = this;
        //     dsBridge.call("photo", {}, function(data) {
        //         lsp.ReversePhoto = "data:image/jpeg;base64," + data;
        //     });
        // },





        ///////////=============== 工作类型 ================
        //初始化工作类型选中状态
        initWorkTypeList() {
            let self = this;
            this.workTypeList.map(typeItem => {
                typeItem.Selected = false;
            });
            if (this.info.ServantSkill && this.info.ServantSkill.length > 0) {
                this.info.ServantSkill.map(item => {
                    self.workTypeList.map(typeItem => {
                        if (typeItem.Key == item.JobType) {
                            typeItem.Selected = true;
                        }
                    });
                });
            }
        },
        //选择工作类型
        chgWorkType(paramId, paramIndex) {
            let self = this;
            let curItemId = this.workTypeList[paramIndex].Key;
            let curIndex = paramIndex;
            // let curItemId = paramId;
            // let curIndex = 0;
            // for(let i=0; i<self.workTypeList.length; i++){
            //     if(self.workTypeList[i].Key == curItemId){
            //         curIndex = i;
            //         break;
            //     }
            // }
            let isExist = false;
            if (self.info.ServantSkill && self.info.ServantSkill.length > 0) {
                for (let i = 0; i < self.info.ServantSkill.length; i++) {
                    if (self.info.ServantSkill[i].JobType == curItemId) {
                        isExist = true;
                        let curItem = JSON.parse(JSON.stringify(self.info.ServantSkill[i]));
                        if (self.workTypeList[curIndex].Selected) {
                            curItem.IsDelete = true; //删除
                            self.workTypeList[curIndex].Selected = false;
                        } else {
                            curItem.IsDelete = false; //不删除
                            self.workTypeList[curIndex].Selected = true;
                        }
                        self.info.ServantSkill.splice(i, 1, curItem);
                    }
                }
            }
            if (!isExist) {
                let newItem = {
                    JobType: curItemId,
                    JobTypeStr: self.workTypeList[curIndex].Name,
                    ExpectedSalary: null,
                    WorkTimes: [{
                        TimeId: 0,
                        BenginTime: "",
                        EndTime: "",
                        IsDelete: false,
                    }],
                    WorkingYears: null,
                    CityId: self.$getCity(),
                    Address: "",
                    IsDelete: false,
                };
                self.info.ServantSkill.push(newItem);
                self.workTypeList[curIndex].Selected = true;
            }
            // if (self.workTypeList[curIndex].Selected) { //已选中
            //     for (let i = 0; i < self.info.ServantSkill.length; i++) {
            //         if (self.info.ServantSkill[i].JobType == curItemId) {
            //             // self.info.ServantSkill.splice(i, 1);
            //             let curItem = JSON.parse(JSON.stringify(self.info.ServantSkill[i]));
            //             curItem.IsDelete = true; //删除
            //             self.info.ServantSkill.splice(i,1,curItem);
            //             // break;
            //         }
            //     }
            //     self.workTypeList[curIndex].Selected = false;
            // } else {
            //     let newItem = {
            //         JobType: curItemId,
            //         JobTypeStr: self.workTypeList[curIndex].Name,
            //         ExpectedSalary: null,
            //         WorkTimes: [{}],
            //         WorkingYears: null,
            //         CityId: self.$getCity(),
            //         Address: "",
            //         IsDelete: false,
            //     };
            //     self.info.ServantSkill.push(newItem);
            //     self.workTypeList[curIndex].Selected = true;
            // }
            console.log(self.workTypeList[curIndex]);
            console.log(self.info.ServantSkill);
        },
        //添加工作时间
        addWorkTime: function(sk) {
            sk.WorkTimes = sk.WorkTimes || [];
            sk.WorkTimes.push({
                TimeId: 0,
                BenginTime: "",
                EndTime: "",
                IsDelete: false,
            });
        },
        //选择工作开始时间
        checkWorkTimeStart: function(options) {
            //{"Name":"3:00","Value":3,"dove":"0_1"}
            if (options.dove === undefined) return;
            var doveArr = options.dove.split('_');
            this.info.ServantSkill[doveArr[0]].WorkTimes[doveArr[1]].BenginTime = options.BenginTime;
        },
        //选择工作结束时间
        checkWorkTimeEnd: function(options) {
            if (options.dove === undefined) return;
            var doveArr = options.dove.split('_');
            this.info.ServantSkill[doveArr[0]].WorkTimes[doveArr[1]].EndTime = options.EndTime;
        },
        //选择行政区域
        checkAddress: function(options) {
            if (options.dove === undefined) return;
            var sk = this.info.ServantSkill[options.dove];
            sk.AreaId = options.Id;
            sk.AreaName = options.Areaname;
            sk.CityId = this.$getCity();
        },

        pickWokingSkills: function(ws, wsIdx) {
            this.info.ListWorkingSkills = this.info.ListWorkingSkills || [];
            if (ws.checked) {
                ws.checked = false;

                var delIdx = -1;
                for (var i = 0; i < this.info.ListWorkingSkills.length; i++) {
                    if (this.info.ListWorkingSkills[i].SkillType == ws.SkillType) {
                        delIdx = i;
                        break;
                    }
                }
                if (delIdx >= 0) {
                    this.info.ListWorkingSkills.splice(delIdx, 1);
                    console.log(this.info.ListWorkingSkills);
                }
            } else {
                ws.checked = true;
                this.info.ListWorkingSkills.push({
                    SkillType: ws.SkillType,
                    SkillTypeStr: ws.SkillTypeStr,
                });
            }
            this.$set(this.workingSkills, wsIdx, ws);
        },

        bind: function() {
            var _this = this;
            if (!this.existed) return;

            this.$post("/servant/binding", {
                    "ServantId": this.info.ServantId
                },
                function(res) {
                    if (res.Success) {
                        _this.$toast("调取成功");
                        _this.$router.go(-1);
                    } else {
                        _this.$toast(res.Message);
                    }
                }
            );
        },
        //初始化服务内容
        initServiceContentList() {
            let self = this;
            this.serviceContentList.map(item => {
                item.Selected = false;
            });
            if (this.info.ServiceContent) {
                let curSContList = this.info.ServiceContent.split(",");
                curSContList.map(curItem => {
                    self.serviceContentList.map(item => {
                        if (item.Id == parseInt(curItem)) {
                            item.Selected = true;
                        }
                    });
                });
            }
        },
        //选择服务内容
        chgService(itemId) {
            let curSContList = [];
            if (this.info.ServiceContent) {
                curSContList = this.info.ServiceContent.split(",");
            }
            let isExist = false;
            if (curSContList && curSContList.length > 0) {
                curSContList.map((curItem, curIndex) => {
                    if (parseInt(curItem) == parseInt(itemId)) {
                        isExist = true;
                        curSContList.splice(curIndex, 1);
                    }
                });
            }
            if (!isExist) {
                curSContList.push(parseInt(itemId));
            }
            this.info.ServiceContent = curSContList.join(",");
            this.initServiceContentList();
        },
        //验证工作类型
        validateWorkType() {
            let isPass = false;
            if (!this.info.ServantSkill || this.info.ServantSkill.length <= 0) {
                this.$toast("请选择工作类型！");
                isPass = false;
            } else {
                let isRight = false;
                this.info.ServantSkill.map(item => {
                    if (!item.IsDelete) {
                        isRight = true;
                    }
                });
                if (!isRight) {
                    this.$toast("请选择工作类型！");
                    isPass = false;
                } else {
                    isPass = true;
                }
            }
            return isPass;
        },
        save: function() {
            let self = this;
            let isPass = this.validateInfo();
            if (!isPass) {
                this.tab = 'info';
                return false;
            }
            // let isPass2 = this.validateCard();
            // if (!isPass2) {
            //     this.tab = 'idCard';
            //     return false;
            // }
            let isPass3 = this.validateWorkType();
            if (!isPass3) {
                this.tab = 'type';
                return false;
            }
            this.info.Birthday = this.info.Birthday.split("T")[0];
            let info = this.info;
            //info.WorkExperience=this.selectYear.string;
            info.Education = this.selectEducation.Key;
            info.ZodiacType = this.selectZodiac.Key;
            info.MaritalStatus = this.selectMarriage.Key;
            // console.log(info.Education);
            // return false;
            //alert(JSON.stringify(info));
            console.log(info);
            let curApi = "/servant/createservant";
            if (this.platform == 3) {
                curApi = "/servant/editservant";
            }
            this.$post(curApi, {
                    "ServantInfo": info
                },
                function(res) {
                    if (res.Success) {
                        if (self.platform == 3) {
                            self.$toast("保存成功");
                        } else {
                            self.$toast("创建成功");
                            self.$router.go(-1);
                        }
                    } else {
                        self.$toast(res.Message);
                    }
                }
            );
        }
    },
}


// WEBPACK FOOTER //
// ./src/shared/components/server/server-profile.js